export class LoadRunExecution {
	static readonly type = '[RUN EXECUTION] Load Run Execution';
	constructor(public runId: string) {
	}
}
